import React from 'react';
import { dataLayerPush } from '@ertelecom/ui-react/components/helpers';
import { pushOfferToNextStep } from '~/src/api/promo';
import { buyItem } from '~/src/api/shop';
import PopupOffer from './popups/offer';
import PopupActivation from './popups/activation';
import PopupResponse from './popups/response';
import BannerPromo from './bannerPromo';
import PromoCodeThanksSber from '~/src/components/Promo/popups/promoCodeThanksSber';
import GiftCard from './GitfCard';
import * as ST from './giftsStyled';

const CATEGORY = {
    NEW: 'new',
    VIEWED: 'viewed',
    CONNECTED: 'active',
    NOCATEGORY: '',
};

const EVENT = {
    event: 'UAevent',
    category: 'Action sale',
};

const MESSAGE_EMPTY_LIST = 'Загляните позже. Мы обязательно сюда для вас что-нибудь добавим.';

class PromoGifts extends React.Component {
    state = {
        offer: {},
        showActivationPopup: false,
        showOfferPopup: false,
        showResponsePopup: false,
        responseTitle: '',
        responseText: '',
    };

    constructor(props) {
        super(props);
        this.showActivationPopup = this.showActivationPopup.bind(this);
        this.showOfferPopup = this.showOfferPopup.bind(this);
    }

    componentDidMount() {
        this.openPopupFromUrl();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.offers !== this.props.offers) {
            this.openPopupFromUrl();
        }
    }

    openPopupFromUrl() {
        const { offers = [], offerPopupId } = this.props;
        const filteredOffers = offers.filter(offer => offer.id == offerPopupId);

        if (filteredOffers.length) {
            this.setState({
                offer: filteredOffers[0],
                showOfferPopup: true,
            });
        }
    }

    showActivationPopup = (offer) => {
        this.setState({
            showActivationPopup: true,
            offer: offer,
        });
    };

    showOfferPopup = (offer) => {
        const { city } = this.props;
        const buttonLink = offer.button_link;

        if (buttonLink && window) {
            window.open(buttonLink, '_blank');
            return;
        }

        if (offer.category === CATEGORY.NEW) {
            pushOfferToNextStep(city, offer.id, offer.stepId).then(response => {
                offer.stepId = response.data.stepId;
                offer.category = response.data.category;
            });
        }

        this.setState({
            showOfferPopup: true,
            offer: offer,
        });
    };

    closePopup = () => {
        this.setState({
            showOfferPopup: false,
            showActivationPopup: false,
            showResponsePopup: false,
            offer: {},
        });
    };

    connectOffer = (child) => {
        const { city, accessToken } = this.props;
        const { offer } = this.state;

        if (offer.isShop) {
            buyItem(city.domain, accessToken, offer.id)
                .then(() => {
                    this.setState({
                        showResponsePopup: true,
                        showOfferPopup: false,
                        responseTitle: 'Успешно',
                        responseText: 'Заявка на подключение отправлена. Мы свяжемся с вами в ближайшее время.',
                        buttonText: 'Выбрать еще',
                    });
                })
                .catch(() => {
                    this.setState({
                        showResponsePopup: true,
                        showOfferPopup: false,
                        responseTitle: 'Что-то пошло не так',
                        responseText: 'Пожалуйста, попробуйте позже.',
                        buttonText: 'Выбрать еще',
                    });
                });
            return;
        }

        const isActivation = offer.category !== CATEGORY.CONNECTED;

        pushOfferToNextStep(city, offer.id, offer.stepId, child, accessToken).then(response => {
            if (response.status === 200) {
                offer.stepId = +response.data.stepId;
                offer.category = response.data.category;
                dataLayerPush({
                    ...EVENT,
                    action: isActivation ? 'Connect' : 'Disconnect',
                    label: offer.title,
                });
                this.setState({
                    showResponsePopup: true,
                    showOfferPopup: false,
                    responseTitle: isActivation ? 'Подключено' : 'Отключено',
                    responseText: isActivation
                        ? 'Подарки и акции активируются сразу и будут доступны в зависимости от условий акции'
                        : 'Подарки и акции деактивируются сразу',
                    buttonText: 'Выбрать еще',
                });
            } else {
                this.setState({
                    showResponsePopup: true,
                    showOfferPopup: false,
                    responseTitle: `Не удалось ${isActivation
                        ? 'отключить'
                        : 'подключить'} спецпредложение`,
                    responseText: response ? response.data.message : '',
                    buttonText: '',
                });
            }
        }, ({ response }) => {
            this.setState({
                showResponsePopup: true,
                showOfferPopup: false,
                responseTitle: `Ошибка при ${isActivation
                    ? 'подключении'
                    : 'отключении'}`,
                responseText: response && response.data.message ||
                    'Перезагрузите страницу и попробуйте подключить еще раз',
                buttonText: 'Попробовать снова',
            });
        });
    };

    onSuccessSber = () => {
        this.setState({
            showOfferPopup: false,
            showActivationPopup: false,
            showResponsePopup: true,
            responseTitle: 'Подключено',
            responseText: 'Подарки и акции активируются сразу и будут доступны в зависимости от условий акции',
            buttonText: 'Выбрать еще',
        });
    };

    onErrorSber = (error) => {
        this.setState({
            showOfferPopup: false,
            showActivationPopup: false,
            showResponsePopup: true,
            responseTitle: 'Ошибка при подключении',
            responseText: error.message,
            buttonText: 'Попробовать снова',
        });
    };

    render() {
        const {
            showActivationPopup,
            showOfferPopup,
            showResponsePopup,
            offer,
            responseTitle,
            responseText,
            buttonText,
        } = this.state;

        const { offers = [], bannerInfo = {}, isAuth, city } = this.props;

        const isBannerExists = Object.keys(bannerInfo).length > 0;

        return (
            <ST.Wrapper>
                <ST.Blocks data-test='offer-block' isFlex={offers.length > 1}>
                    {isBannerExists && <BannerPromo bannerInfo={bannerInfo}/>}
                    {offers.length
                        ?   <ST.OffersRow>
                                {offers.map(item => (
                                    <GiftCard
                                        key={item.id}
                                        item={item}
                                        showOfferPopup={this.showOfferPopup}
                                        city={city}
                                    />
                                ))}
                            </ST.OffersRow>
                        :   MESSAGE_EMPTY_LIST
                    }
                </ST.Blocks>

                <PopupActivation
                    onClose={this.closePopup}
                    isOpen={showActivationPopup}
                    type={offer.type}
                />

                <RenderPopupOffer
                    onClose={this.closePopup}
                    isOpen={showOfferPopup}
                    offer={offer}
                    isConnected={offer.category === CATEGORY.CONNECTED}
                    activate={this.connectOffer}
                    onErrorSber={this.onErrorSber}
                    onSuccessSber={this.onSuccessSber}
                    isAuth={isAuth}
                />

                <PopupResponse
                    isOpen={showResponsePopup}
                    onClose={this.closePopup}
                    title={responseTitle}
                    text={responseText}
                    buttonText={buttonText}
                    onButtonClick={this.closePopup}
                />
            </ST.Wrapper>
        );
    }
}

export const THANKS_SB_2 = 1312;
export const THANKS_SB_3 = 1313;

function RenderPopupOffer({ onClose, isOpen, offer, isConnected, activate, onErrorSber, onSuccessSber }) {
    switch (offer.id) {
        case THANKS_SB_2:
        case THANKS_SB_3:
            return <PromoCodeThanksSber
                isOpen={isOpen}
                onClose={onClose}
                offer={offer}
                onError={onErrorSber}
                onSuccess={onSuccessSber}
            />;
        default:
            return <PopupOffer
                onClose={onClose}
                isOpen={isOpen}
                offer={offer}
                isConnected={isConnected}
                activate={activate}
            />;
    }
}

export default PromoGifts;
